export enum Currency {
  ZAR = 'ZAR',
  XBT = 'XBT',
  ETH = 'ETH',
  USD = 'USD'
}
